import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import { withRouter } from "../../../providers/withRouter";
import Excel from "../../../icons/excel.svg";
import { getListSalesToExport } from "../../../services";
import { toast } from "react-toastify";


const ExportarListaComunidades = (props) => {
  const { t } = useTranslation(['properties', 'common']);
  const [isLoading, setIsLoading] = useState(false);

  const exportar = async () => {
    if (isLoading) return;
    setIsLoading(true);
    const toastId = toast.loading(t('common:excel.generatingExcel'));
    try {
      const payload = props.payload || {};
      const data = await getListSalesToExport({ filtros: payload.filtros || {} });

      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `servicios_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.update(toastId, {
        render: t('common:excel.excelSuccess'),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t('common:excel.excelError'),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const isDisabled = isLoading || props.disabled;

  return (
    <button
      className={`bigBtn ${isDisabled ? 'disabled' : ''}`}
      onClick={exportar}
      disabled={isDisabled}
    >
      {!isLoading ? (
        <>
          <img src={Excel} alt={t('common:technicians.generateList')} width="30px" />
          {t('common:technicians.generateList')}
        </>
      ) : (
        <>
          <CircularProgress
            style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }}
          />
          {t('management.generatingList')}
        </>
      )}
    </button>
  );
};

export default withRouter(ExportarListaComunidades);
